export function adminRedirect(pathname: string, search: string): string | null {
  if (pathname === '/rails') {
    const q = new URLSearchParams(search);
    if (q.get('tab') === 'snowflake' || q.get('tab') === 'billing') return null;
    if (q.get('tab') === 'access') {
      const view = q.get('view');
      if (view === 'group' && q.get('group')) return `/admin/people/group/${encodeURIComponent(q.get('group')!)}`;
      if (view === 'person' && q.get('person')) return `/admin/people/person/${encodeURIComponent(q.get('person')!)}`;
      return '/admin/people';
    }
    if (q.get('tab') === 'people' || (q.get('tab') === 'rails' && !q.has('railsTab'))) return '/admin/people';
    // MA5: each old tab moves with the area it now lives in (brief 8).
    const railsTab = q.get('tab') === 'rails' ? q.get('railsTab') : null;
    if (railsTab === 'walls' || railsTab === 'routes' || railsTab === 'wellbeing') return '/admin/privacy';
    if (railsTab === 'policy') return '/admin/policy';
    if (q.get('tab') === 'connectors') return '/admin/sources';
    if (q.get('tab') === 'brains') return '/admin/decides';
    return '/admin';
  }
  if (pathname === '/superadmin') {
    // The vault's step-up returns keep stepup= and why=; the Super admin page itself was How Cobrain decides' Training.
    const q = new URLSearchParams(search);
    if (q.has('stepup') || q.has('why')) {
      const kept = new URLSearchParams();
      for (const key of ['stepup', 'why']) { const value = q.get(key); if (value !== null) kept.set(key, value); }
      return `/admin/vault?${kept}`;
    }
    return '/admin/decides';
  }
  if (pathname === '/usage') return '/admin/spend';
  return null;
}
